import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { formatChartNumber } from '@/lib/charts/format';
import { ref } from 'vue';

export default function useChartValueFormatter(chart = ref({})) {
  const { userLang } = useLoggedInUser();
  const formatValue = (value) => formatChartNumber(value, {
    precision: chart.value.precision,
    locale: userLang.value,
  });
  return { formatValue };
}
